<template>
	<el-container>
		<el-main class="reviewTaskManageMain-wrap">
			<div class="reviewTaskManageMain mt6">
				<div class="filter filterReviewDetail">
					<el-form
						ref="form"
						:model="form"
						label-width="80px"
						class="clearfix"
					>
						<el-form-item label="审查状态">
							<el-select
								v-model="form.status"
								placeholder="请选择"
								:popper-append-to-body="false"
							>
								<el-option
									v-for="item in statusOptions"
									:key="item.code"
									:label="item.brief"
									:value="item.code"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="审查进度">
							<el-input v-model.trim="form.process"></el-input>
						</el-form-item>
						<el-form-item label="时间">
							<el-date-picker
								v-model="form.time"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<div class="operation fl operationReviewDetail">
							<a class="new f_transition" @click="resetFun">
								<i class="iconfont icon-zhongzhi"></i>
								重置
							</a>
							<a class="new f_transition" @click="searchTable">
								<i class="iconfont icon-chaxun1"></i>
								查询
							</a>
						</div>
					</el-form>
				</div>
				<div class="tableBox tableBoxReviewDetail">
					<el-table
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						style="width: 100%"
						v-loading="loading"
					>
						<!-- <el-table-column type="selection" width="66">
						</el-table-column> -->
						<el-table-column
							prop="title"
							label="审查环节"
							min-width="20%"
							align="center"
							:show-overflow-tooltip="true"
						>
						</el-table-column>
						<el-table-column
							prop="type__brief"
							label="审查环节状态"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="process__brief"
							label="审查进度"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="stage__brief"
							label="部门"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="author"
							label="操作人"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="status__brief"
							label="开始时间"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">{{
								handleTime(scope.row.status__brief)
							}}</template>
						</el-table-column>
						<el-table-column
							label="结束时间"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">{{
								handleTime(scope.row.create_time)
							}}</template>
						</el-table-column>
						<el-table-column
							label="操作意见建议"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">{{
								handleTime(scope.row.create_time)
							}}</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page pt15 pb15 clearfix pageReviewDetail">
					<el-pagination
						@size-change="handleSizeChangeDeclare"
						@current-change="handleCurrentChangeDeclare"
						:current-page.sync="currentPageDeclare"
						:page-size="pageSize"
						background
						layout="total ,prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</div>
		</el-main>
	</el-container>
</template>
<script>
export default {
	data() {
		return {
			//筛选条件start==
			statusOptions: [
				//审查状态
				{
					code: "null",
					brief: "全部",
				},
			],
			form: {
				status: "null", //审查状态
				process: "", //审查进度
				time: [], //时间
			},
			//筛选条件end==

			//表格start==
			loading: false, //加载中
			tableData: [],
			multipleSelection: [], //表格选中数据
			//表格end==

			//分页start==
			currentPageDeclare: 1, //当前页
			total: 0, // 总共条数
			pageSize: 5, //每页的数量
			//分页end==
		};
	},
	created() {
		this.statusDataFun(); //审查状态
		this.tableFun(1);
	},
	methods: {
		//分页
		handleSizeChangeDeclare(size) {
			// console.log(`每页 ${size} 条`);
			this.pageSize = size;
			this.tableFun(this.currentPageDeclare);
		},
		handleCurrentChangeDeclare(currentPage) {
			// console.log(`当前页: ${currentPage}`);
			this.currentPageDeclare = currentPage;
			this.tableFun(this.currentPageDeclare);
		},
		//将时间中的T换成空格
		handleTime(t) {
			t = t.replace(new RegExp(/(T)/g), "\u00a0");
			return t;
		},
		//重置
		resetFun() {
			this.form.type = "null"; //审查类型
			this.form.status = "null"; //审查状态
			this.form.stage = "null"; //审查环节
			this.form.process = ""; //审查进度
			this.form.title__contains = ""; //标题
			this.form.author_name__contains = ""; //创建人
			this.form.time = []; //时间
			this.tableFun(1);
		},
		//域内检索
		searchTable() {
			this.tableFun(1);
		},
		//获取table中的数据
		tableFun(str) {
			this.loading = true; //加载中显示
			let startTime = "";
			let endTime = "";
			if (this.form.time&&this.form.time.length > 0) {
				startTime = this.form.time[0];
				endTime = this.form.time[1];
			} else {
				startTime = "";
				endTime = "";
			}
			this.axios
				.get(
					"/japi/check/check_items_handle/?page=" +
						str +
						"&page_num=" +
						this.pageSize +
						"&type=" +
						this.form.type +
						"&status=" +
						this.form.status +
						"&process=" +
						this.form.process +
						"&title__contains=" +
						this.form.title__contains +
						"&author_name__contains=" +
						this.form.author_name__contains +
						"&create_time__gte=" +
						startTime +
						"&create_time__lte=" +
						endTime
				)
				.then((res) => {
					console.log("审查任务管理表格数据======");
					console.log(res);
					if (res.status == 200) {
						this.total = res.data.data.sum;
						this.tableData = res.data.data.res;
						this.loading = false; //加载中隐藏
					} else {
						console.log("请求数据失败！");
						this.$message.error("请求数据失败！");
					}
				});
		},

		//审查状态
		statusDataFun() {
			this.axios.get("/japi/check/get_all_check_status/").then((res) => {
				console.log("审查状态数据======");
				if (res.status == 200) {
					console.log(res);
					//将两个数组合并
					this.statusOptions = this.statusOptions.concat(
						res.data.data
					);
				} else {
					console.log("审查状态数据请求失败！");
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>